<template>
    <div class="tab-text">
        <div class="vx-row w-1/2 mb-6 mt-3 ml-5">
            <vs-button class="mt-2" v-if="hasPermission(`create`)" color="primary" type="border" icon-pack="feather" icon="icon-plus"
                @click="handleCreate()">Create</vs-button>
            <vs-button v-if="hasPermission(`import`)" class="mt-2 ml-3" color="success" type="border" icon-pack="feather" icon="icon-download"
                @click="handleImport()">Import</vs-button>
        </div>
        <div class="vx-col w-1/2 mb-6 mt-3 ml-5">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/4 w-full">
                    <span>Work Order ID</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <v-select :multiple="false" :filterable="true" :options="optionWorkOrderID"
                        v-model="selectedWorkOrderID" :placeholder="placeholder" label="Code" />
                    <!-- <multiselect class="selectExample" v-model="selectedWorkOrderID" :options="optionWorkOrderID"
                        :multiple="false" :allow-empty="false" :group-select="false" :max-height="100" :limit="3"
                        placeholder="Type to search" :searchable="true" :custom-label="customLabelWorkOrder" /> -->
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/4 w-full">
                    <span>Request Date</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <datepicker name="date" :inline="false" v-model="requestDate" placeholder="Select Date"
                        :cleared="() => { this.requestDate = null }"></datepicker>
                    <!-- <vs-input class="w-full" v-model="requestDate" type="date" v-validate="'required'" /> -->
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-2/3 w-full">
                    <span></span>
                </div>
                <vs-button @click="onClickBtnFilter" size="medium" color="primary" icon-pack="feather"
                    icon="icon-search" title="Search">
                    Filter
                </vs-button>
                <vs-button @click="onClickBtnClear" size="medium" class="ml-2" color="primary" icon-pack="feather"
                    icon="icon-search" title="Search">
                    Clear
                </vs-button>
            </div>
        </div>

        <div class="vx-row mb-12">
            <div v-bind:class="[
                mutualAction == 'edit' || mutualAction == 'create' ? detailShow : '',
                detailHide,
            ]">
                <data-table :baseUrl="baseUrl" @id="setId" @action="setAction" :action="mutualAction" :status="1"
                    :workOrderID="selectedWorkOrderID.Code" :date="requestDate" :isFilter="isfilter"
                    @isFilter="setFilter"></data-table>
            </div>
            <transition name="detail-fade">
                <div v-if="mutualAction == 'edit' || mutualAction == 'create'" v-bind:class="[
                    mutualAction == 'edit' || mutualAction == 'create'
                        ? detailShow
                        : '',
                    detailHide,
                ]">
                    <vs-row>
                        <vs-col style="padding-bottom: 8px" vs-offset="8" vs-type="flex" vs-justify="right"
                            vs-align="right" vs-w="4">
                            <vs-button class="ml-auto" size="small" v-on:click="handleClose" color="grey"
                                icon-pack="feather" icon="icon-x-square">Close</vs-button>
                        </vs-col>
                        <vs-col class="vertical-divider" vs-offset="0" vs-type="flex" vs-justify="center"
                            vs-align="center" vs-w="1">
                            <vs-button size="small" v-on:click="handleClose" color="grey" icon-pack="feather"
                                icon="icon-x-square"></vs-button>
                        </vs-col>
                        <data-form v-if="mutualAction == 'edit' || mutualAction == 'create'" :id="id" :baseUrl="baseUrl"
                            :title="title" @action="setAction" @close="handleClose"></data-form>
                    </vs-row>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import DataTable from "../DataTable";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";


// import DataForm from "./DataForm";
export default {
    components: {
        DataTable,
        Datepicker,
        vSelect,
        // DataForm,
    },
    data() {
        return {
            title: "Work Order",
            baseUrl: "api/wms/v1/work-order",
            detailShow: "core vx-col md:w-1/2 w-full mb-base ",
            detailHide: "core vx-col md:w-1/1 w-full mb-base ",
            mutualAction: "",
            id: null,
            requestDate: null,
            optionWorkOrderID: [],
            selectedWorkOrderID: { Code: "", id: null },
            isfilter: false
        };
    },
    methods: {
        handleCreate() {
            this.$router.push({
                name: "work-order-ho-create",
            });
        },
        handleImport() {
            this.$router.push({
                name: "work-order-ho-import",
            });
        },
        setFilter(val) {
            this.isfilter = val;
        },
        handleClose() {
            window.scrollTo(0, 0);
            this.mutualAction = "";
        },
        setId(val) {
            this.id = val;
        },
        setAction(val) {
            this.mutualAction = val;
        },
        onClickBtnFilter() {
            this.isfilter = true;
        },
        onClickBtnClear() {
            this.selectedWorkOrderID = { Code: "", id: null }
            this.requestDate = null
            this.isfilter = true
        },
        getWarehouse() {
            this.$vs.loading();
            this.$http
                .get("/api/wms/v1/work-order/data", {
                    params: {
                        length: null,
                        order: "id",
                        sort: "asc",
                    },
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        if (resp.data.records) {
                            this.optionWorkOrderID = resp.data.records;
                            if (this.optionWorkOrderID.length > 0) {
                                // this.selectedWorkOrderID = this.optionWorkOrderID[0];
                            } else {
                                this.optionWorkOrderID = [];
                                this.selectedWorkOrderID = { Code: "", id: 0 };
                            }
                        } else {
                            this.optionWorkOrderID = [];
                            this.selectedWarehouse = {};
                        }
                        this.$vs.loading.close();
                    } else {
                        this.$vs.loading.close();
                    }
                });
        },
        customLabelWorkOrder({ Code }) {
            return `${Code} `;
        },
    },
    mounted() {
        this.$store.dispatch("user/getPermissions", "work-order");
        // this.getData();
        this.getWarehouse();
    },
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
    },
};
</script>

<style scoped>
.core-enter-active {
    transition: all 0.3s ease;
}

.core-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.core-enter,
.core-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
}

.core {
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    transition: all 1s ease;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table {
    font-size: 12px;
}

.vertical-divider {
    border-left: 1px solid #7367f0;
    /* min-height: 800px; */
    padding: 5px;
}
</style>
